import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="guest-user-bar"
// SP の求人詳細でヘッダー（ロゴ部）がスクロールで流れたあともゲストバーを画面上部に固定する。
// is_fixed の CSS は求人詳細スコープ（body:has(#wrapper .jobDetail_nav)）にのみ定義されている。
export default class extends Controller {
  private onScrollBound: () => void;
  private onResizeBound: () => void;
  private headerHeight = 0;
  private active = false;

  connect() {
    // ページ内タブバー（求人詳細）がなければバー固定は不要
    if (!document.querySelector("#wrapper .jobDetail_nav")) return;

    this.active = true;
    this.onScrollBound = this.onScroll.bind(this);
    this.onResizeBound = this.onResize.bind(this);

    this.updateHeaderHeight();
    window.addEventListener("scroll", this.onScrollBound, { passive: true });
    window.addEventListener("resize", this.onResizeBound);

    // 初期表示位置に合わせて一度実行
    this.onScroll();
  }

  disconnect() {
    if (!this.active) return;

    window.removeEventListener("scroll", this.onScrollBound);
    window.removeEventListener("resize", this.onResizeBound);
    this.element.classList.remove("is_fixed");
  }

  private updateHeaderHeight(): void {
    const headerContainer = document.querySelector<HTMLElement>(".header_container");
    this.headerHeight = headerContainer ? headerContainer.offsetHeight : 0;
  }

  private onScroll(): void {
    // SP 表示のみ（PC はヘッダー自体が固定されるため不要）
    if (window.innerWidth > 768) {
      this.element.classList.remove("is_fixed");
      return;
    }

    // ヘッダー（ロゴ部）の高さ分スクロールしたらバーを画面上部に固定する
    if (window.scrollY >= this.headerHeight) {
      this.element.classList.add("is_fixed");
    } else {
      this.element.classList.remove("is_fixed");
    }
  }

  private onResize(): void {
    this.updateHeaderHeight();
    this.onScroll();
  }
}
